import { createAction } from '@reduxjs/toolkit';
export const PROCESS_CALL_RECORDING = 'PROCESS_CALL_RECORDING';
export const processCallRecordingAction = createAction(PROCESS_CALL_RECORDING);